module.exports = __webpack_public_path__ + "img/ho.c7c64153.svg";